/* global zzl */
const localURL = zzl.env.canonical || window.location.pathname
console.log(zzl.env.canonical)
if (/\/navi\/try\/entry03\/072[78]/.test(localURL)) {
	initInputForm()
}

function initInputForm () {
	const form = document.querySelector('.entry-form')
	if (!form) return

	const [numForm, persons, insertPoint] = initDOM(form)
	let num = getNum(numForm)
	updateNum(num, persons, insertPoint)

	numForm.addEventListener('change', () => {
		const newNum = getNum(numForm)
		if (num !== newNum) {
			updateNum(newNum, persons, insertPoint)
			num = newNum
		}
	})
}

function initDOM (form) {
	const items = [].map.call(form.querySelectorAll('.entry-form-item'), el => {
		const labelText = el.querySelector('.entry-form-label').firstChild
		const label = labelText.nodeValue.trim().replace(/（[二三]人目）/u, '')
		labelText.nodeValue = label + ' '
		return { el, label }
	})

	const numForm = items.find(item => /参加人数/.test(item.label)).el

	const persons = []
	let i = -1
	let insertPoint = null
	items.forEach(item => {
		const inPersonSection = /参加者氏名|性別|保護者|電話|住所|mail/i.test(item.label)
		if (!inPersonSection) {
			if (i >= 2 && !insertPoint) {
				insertPoint = item.el
			}
			return
		}
		if (/参加者氏名（漢字）/.test(item.label)) {
			i++
		}
		if (!persons[i]) {
			const groupLabel = `${i + 1}人目`
			const groupEl = document.createElement('div')
			groupEl.setAttribute('style', 'margin: 1.5em 0')
			const groupText = document.createElement('h4')
			groupText.textContent = groupLabel
			groupText.setAttribute('style', 'padding: .25em .5em; background: #d4d4d4')
			groupEl.appendChild(groupText)
			item.el.parentNode.insertBefore(groupEl, item.el)
			persons[i] = {
				groupLabel,
				groupEl,
				items: []
			}
		}
		persons[i].items.push(item)
		persons[i].groupEl.appendChild(item.el)
	})
	return [numForm, persons, insertPoint]
}

function getNum (numForm) {
	const numInputs = numForm.querySelectorAll('input[type="radio"]')
	if (numInputs.length === 0) {
		// 確認画面
		return parseNum(numForm.querySelector('.entry-form-values').textContent)
	} else {
		const checked = [].find.call(numInputs, el => el.checked)
		if (!checked) {
			numInputs[0].checked = true
			return 1
		}
		return parseNum(checked.value)
	}
}

function parseNum (str) {
	return parseInt(String(str).replace('名'), 10)
}

function updateNum (num, persons, insertPoint) {
	const parent = persons[0].groupEl.parentNode
	for (let i = num; i < persons.length; i++) {
		if (persons[i].groupEl.parentNode === parent) {
			parent.removeChild(persons[i].groupEl)
		}
	}
	for (let i = 1; i < num; i++) {
		parent.insertBefore(persons[i].groupEl, insertPoint)
	}
}
